import { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import StandardCheckbox from "../../elements/buttons/standardCheckbox.button.jsx";
import StandardInstruction from "../../elements/text/standardInstruction.component.jsx";

export default function Event(props) {
  const [patientsInterested, setPatientsInterested] = useState(
    props.settings.patientsInterested
  );
  const [professionalAudience, setProfessionalAudience] = useState(
    props.settings.professionalAudience
  );
  const container = useRef(null);

  useEffect(() => {
    if (!patientsInterested && !professionalAudience) {
      container.current.classList.add("shake");
      setTimeout(() => {
        container.current.classList.remove("shake");
      }, 500);
      return;
    }

    const settings = {
      event: {
        professionalAudience,
        patientsInterested,
      },
    };
    props.setProperties(settings);
  }, [patientsInterested, professionalAudience]);

  return (
    <div className="d-flex flex-column">
      <StandardInstruction className={"mb-4"}>{props.text}</StandardInstruction>
      <div ref={container}>
        <div
          onClick={() => setPatientsInterested((prevState) => !prevState)}
          className="general-margin-bottom-large d-flex justify-content-between"
        >
          <span>
            <FormattedMessage id="settings.event.patientsInterested" />
          </span>
          <StandardCheckbox checked={patientsInterested} />
        </div>
        <div
          onClick={() => setProfessionalAudience((prevState) => !prevState)}
          className="general-margin-bottom-large d-flex justify-content-between"
        >
          <span>
            <FormattedMessage id="settings.event.professionalAudience" />
          </span>
          <StandardCheckbox checked={professionalAudience} />
        </div>
      </div>
    </div>
  );
}
